import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
} from '@angular/core';
import { WindowService } from '../../services/window.service';
export interface Orcamento {
  data?: string;
  idPedido?: number | string;
  seqPedido?: number;
  orcamentoId?: number;
  orcamentoFilial?: number;
  cliente?: string;
  vendedor?: string;
  total?: string;
  totalValue?: number;
  status: string;
  observacaoPc?: string | null;
  hasView?: boolean;
  hasEdit?: boolean;
  hasClose?: boolean;
}
@Component({
  selector: 'bs-detail-expanded',
  templateUrl: './detail-expanded.component.html',
  styleUrls: ['./detail-expanded.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiDetailExpandedComponent implements OnInit {
  @Input() data!: Orcamento;
  @Input() eventAction!: EventEmitter<Orcamento>;
  private orcamento!: Orcamento;
  constructor(private readonly windowService: WindowService) {}
  ngOnInit(): void {
    this.windowService.windowSize$.subscribe(({ width }) => {
      this.orcamento = this.data;

      if (width <= 400) {
        const data = {
          orcamentoId: this.orcamento.orcamentoId,
          orcamentoFilial: this.orcamento.orcamentoFilial,
          cliente: this.orcamento.cliente,
          vendedor: this.orcamento.vendedor,
          total: this.orcamento.total,
          status: this.orcamento.status,
          hasView: this.orcamento.hasView,
          hasEdit: this.orcamento.hasEdit,
          hasClose: this.orcamento.hasClose,
        };
        this.data = data;
        return;
      }
      if (width <= 550) {
        const data = {
          orcamentoFilial: this.orcamento.orcamentoFilial,
          cliente: this.orcamento.cliente,
          vendedor: this.orcamento.vendedor,
          total: this.orcamento.total,
          status: this.orcamento.status,
          hasView: this.orcamento.hasView,
          hasEdit: this.orcamento.hasEdit,
          hasClose: this.orcamento.hasClose,
        };
        this.data = data;
        return;
      }
      if (width <= 800) {
        const data = {
          cliente: this.orcamento.cliente,
          vendedor: this.orcamento.vendedor,
          total: this.orcamento.total,
          status: this.orcamento.status,
          hasView: this.orcamento.hasView,
          hasEdit: this.orcamento.hasEdit,
          hasClose: this.orcamento.hasClose,
        };
        this.data = data;

        return;
      }
      if (width <= 1100) {
        const data = {
          vendedor: this.orcamento.vendedor,
          total: this.orcamento.total,
          status: this.orcamento.status,
          hasView: this.orcamento.hasView,
          hasEdit: this.orcamento.hasEdit,
          hasClose: this.orcamento.hasClose,
        };
        this.data = data;
        return;
      }
      if (width <= 1200) {
        const data = {
          total: this.orcamento.total,
          status: this.orcamento.status,
          hasView: this.orcamento.hasView,
          hasEdit: this.orcamento.hasEdit,
          hasClose: this.orcamento.hasClose,
        };
        this.data = data;
        return;
      }
      if (width <= 1350) {
        const data = {
          status: this.orcamento.status,
          hasView: this.orcamento.hasView,
          hasEdit: this.orcamento.hasEdit,
          hasClose: this.orcamento.hasClose,
        };
        this.data = data;
        return;
      }
    });
  }
}
